exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remita {\r\n    background: linear-gradient(to bottom right, #F26524, #c94204);\r\n    -webkit-text-fill-color: #ffffff;\n}\n.remita:hover {\r\n    background: linear-gradient(to bottom right, #953002, #F26524);\n}\n.monni {\r\n    background: linear-gradient(to bottom right, #00B8C2, #01777d);\r\n    -webkit-text-fill-color: #ffffff;\n}\n.monni:hover {\r\n    background: linear-gradient(to bottom right, #01777d, #00B8C2);\n}\n.pos-payment-transfer-checkout {\r\n  padding: 20px;\n}\r\n", ""]);

// exports
